<template>
  <div>
    <figure :class="style['message']" role="group">
      <p v-if="showFacebookLogout" :class="style['chat-message']">
        {{ $t('facebook.sign_out') }}
      </p>
      <p v-else :class="style['chat-message']">
        {{ $t('destroy_session.information') }}
      </p>
      <figure-caption-user :settings="settings" />
    </figure>

    <button
      type="button"
      :class="[style['user-input'], style['submit-button']]"
      :disabled="isSending"
      @click="handleSignOut"
    >
      <span v-if="!isSending">{{ $t('destroy_session.submit') }}</span>
      <t-spinner v-else small></t-spinner>
    </button>

    <button
      v-if="showFacebookLogout"
      type="button"
      :class="[style['user-input'], style['facebook']]"
      :disabled="isSending"
      @click="signOutOauth"
    >
      {{ $t('user_top.sign_out_with_facebook') }}
    </button>

    <iframe
      v-if="showBWIframe"
      ref="bwIframe"
      style="position: absolute; left: -999em"
      :src="bwIframeSrc"
      @load="onBWIframeLoaded"
    ></iframe>
  </div>
</template>

<script>
import { User } from 'src/apis'
import { EventBus } from 'ChatWidget/EventBus'
import FigureCaptionUser from './FigureCaptionUser.vue'
import style from './scss/_users.scss'
import { removeSession } from 'Utilities/Session'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'
import { useUserStore } from 'Store/user'
import { useAppStore } from 'Store/app'
import { useSettingsStore } from 'Store/settings'
import { mapState } from 'pinia'
import { useChatStore } from 'Store/chat'

export default {
  components: {
    FigureCaptionUser
  },
  props: {
    closeUserPanel: { type: Function, required: true }
  },

  setup() {
    return {
      userStore: useUserStore(),
      appStore: useAppStore(),
      settingsStore: useSettingsStore(),
      chatStore: useChatStore()
    }
  },

  data() {
    return {
      isSending: false,
      showBWIframe: false,
      isLoggingOut: false,
      style
    }
  },

  computed: {
    ...mapState(useSettingsStore, {
      facilitySignInEnabled: 'getFacilitySignIn',
      settings: 'getSettings'
    }),

    baseURL() {
      return this.appStore.baseURL
    },

    knownUser() {
      return this.userStore.user
    },

    bwIframeSrc() {
      const bwUrl = this.settingsStore.bookingWidgetURL
      return `${bwUrl}/sign-out?code=${this.appStore.websiteFacilityCode}&parentUrl=${location.origin}&uri=${this.baseURL}&iframe=triplabot`
    },

    facebookLogoutURL() {
      return `${this.baseURL}users/${this.knownUser.id}/auth/facebook/logout`
    },

    showFacebookLogout() {
      return this.knownUser.provider === 'facebook'
    }
  },
  methods: {
    onBWIframeLoaded() {
      this.$refs['bwIframe'].contentWindow.postMessage(
        { action: 'logout' },
        this.settingsStore.bookingWidgetURL
      )
    },

    signOutOauth() {
      if (this.knownUser.provider !== 'facebook') return false
      window.open(this.facebookLogoutURL, 'popup', 'width=600, height=600')
      this.handleSignOut()
    },

    logoutBW() {
      return new Promise((resolve) => {
        this.showBWIframe = true

        const messageListener = (event) => {
          if (event.origin !== this.settingsStore.bookingWidgetURL) return
          if (event.data.action === 'login' && !event.data.name) {
            window.removeEventListener('message', messageListener)
            resolve()
          }
        }

        window.addEventListener('message', messageListener)
      })
    },

    handleSignOut() {
      this.isSending = true
      const options = {
        signOut: true
      }
      this.chatStore.changeChat(triplaLocalStorage.getItem('original_brand_hotel_code'), options)
      if (
        this.facilitySignInEnabled &&
        triplaLocalStorage.getItem('triplabot_auth') === 'triplapbot_membership'
      ) {
        this.logoutBW().then(() => {
          this.isSending = false
          this.closeUserPanel()
          EventBus.$emit('toggle-chat')
          // refresh chat will be handled in App.vue
        })
      } else {
        User.SignOutKnownUser()
          .then((json) => {
            this.isSending = false
            this.userStore.$reset()
            removeSession()
            this.closeUserPanel()
            // refresh the chat messages on top App.vue
            this.chatStore.refreshChat()
            EventBus.$emit('toggle-chat')
            this.appStore.setMinimized(false)
          })
          .catch((error) => {
            this.isSending = false
            console.error(error)
          })
      }
    }
  }
}
</script>
